import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  HostListener,
  ViewChild,
  ElementRef,
  Output,
  EventEmitter,
} from "@angular/core";
import { Router } from "@angular/router";
import { CloudUser } from 'src/app/shared/user/cloud-user';

@Component({
  standalone: false,
  selector: "app-openground-header",
  templateUrl: "./openground-header.component.html",
  styleUrls: ["./openground-header.component.scss"],
})
export class OpengroundHeaderComponent implements OnInit, OnDestroy {
  @Input() cloudName;

  @Input() changeCloudVisible = true;

  @Input() logoutVisible = true;

  @Input() resetPasswordVisible = false;

  @Input() firstName: string;

  @Input() lastName: string;

  @Input() email: string;

  @Input() fullName: string;

  @Input() initials: string;

  @Output() changeCloud = new EventEmitter<any>();

  @Output() signOff = new EventEmitter<any>();

  @Output() resetPassword = new EventEmitter<any>();

  profileDropDownOpen;


  constructor() {}

  @ViewChild("popup", { static: true }) myDiv: ElementRef;

  @HostListener("window:mouseup", ["$event"])
  onMouseUp(e: MouseEvent) {
    if (
      this.myDiv.nativeElement !== e.target &&
      !this.myDiv.nativeElement.querySelector("#popup *")
    ) {
      this.profileDropDownOpen = false;
    }
  }

  ngOnInit() {
  }

  ngOnDestroy() {}

  toggleProfileDropDownOpen() {
    this.profileDropDownOpen = !this.profileDropDownOpen;
  }

  onSignOff() {
    this.signOff.emit();
  }

  onChangeCloud() {
    this.changeCloud.emit();
  }
}
